<template>
  <div class="card-flip">
    <!-- <div class="card-item" v-for="item in list" :key="item.ID"> -->
    <div
      class="card-item"
      v-for="item in list"
      :key="item.ID"
      @click.stop="onClick(item)"
    >
      <!-- v-if="item.ID !== '-1'" -->
      <!-- 正面 -->
      <div class="front">
        <img class="card-item-img" :src="item[websiteName]" alt="" />
      </div>

      <!-- 反面 -->
      <div class="back">
        <img class="card-item-img" :src="item.BodyPicWebSite" alt="" />
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: "CardFlip",
  props: ["cards"],
  data() {
    return {
      list: []
    };
  },
  mounted() {},
  methods: {
    onClick(item) {
      this.$emit("onCardItemClick", item);
    }
  },
  computed: {
    websiteName() {
      let name = "";
      switch (this.$i18n.locale) {
        case "zh":
          name = "PicWebSite";
          break;
        case "en":
          name = "EnglishWebSite";
          break;
        case "sp":
          name = "xibanyaWebSite";
          break;
      }
      return name;
    }
  },
  watch: {
    cards: {
      handler(val) {
        this.list = val.slice(1);
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="less">
.card-flip {
  width: 1200px;
  height: 560px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  overflow-y: auto;

  .card-item {
    width: 224px;
    height: 125px;
    position: relative;
    transition: all 1s;
    transform-style: preserve-3d;
    margin: 0 18px 18px 0;

    &:nth-child(5n) {
      margin-right: 0;
    }

    &:hover {
      transform: rotateY(180deg);
    }

    .front,
    .back {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }

    //正面
    .front {
      z-index: 1;
      backface-visibility: hidden;
      opacity: 1;
    }

    //反面
    .back {
      transform: rotateY(180deg);
      transform-style: preserve-3d;
      position: relative;
    }

    .card-item-img {
      //   display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
